export default "__VITE_ASSET__CE51e9wV__"